import { Action, State } from './SavedListing.types';

const reducer = (state: State, action: Action) => {
    switch (action.type) {
        case 'INITIALISE':
            return {
                ...state,
                listingId: action.payload.listingId,
                isUser: action.payload.isUser,
                isSaved: action.payload.isSaved,
                isSavedOptimistically: action.payload.isSaved,
                isUpdatingServer: false
            };

        case 'RESET':
            return {
                listingId: undefined,
                isUser: undefined,
                isSaved: undefined,
                isSavedOptimistically: undefined,
                isUpdatingServer: undefined
            };

        case 'LISTING_SAVED':
            return {
                ...state,
                isSaved: true,
                isSavedOptimistically: true,
                isUpdatingServer: false
            };

        case 'LISTING_REMOVED':
            return {
                ...state,
                isSaved: false,
                isSavedOptimistically: false,
                isUpdatingServer: false
            };

        case 'UPDATE_SERVER_STARTED':
            return {
                ...state,
                isSavedOptimistically: !state.isSaved,
                isUpdatingServer: true
            };

        case 'UPDATE_SERVER_FAILED':
            return {
                ...state,
                isSavedOptimistically: state.isSaved,
                isUpdatingServer: false
            };

        case 'USER_REGISTERED':
            return {
                ...state,
                isUser: true
            };

        default:
            return state;
    }
};

export default reducer;
